import { ThemeProvider, createTheme } from "@mui/material";
import { Url } from "../../constants/ApiUrlConstants";
import { FaCheckCircle } from 'react-icons/fa';
import { IoIosShareAlt } from 'react-icons/io';
import { BsEye, BsDownload } from 'react-icons/bs';
import { SlPencil } from 'react-icons/sl';
import DatePicker from 'react-datepicker';
import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import {
    FaPlusSquare,
    FaCheck,
    FaTimes,
    FaTrash,
    FaChevronRight,
    FaEdit,
    FaSave,
    FaFilter,
    FaAngleDoubleLeft,
    FaAngleDoubleRight,
    FaChevronLeft,
    FaMinus,
    FaSearch,
    FaThList
} from 'react-icons/fa';
import MaterialTable from "material-table";
import { PUT } from "../Common/HttpMethods/HttpMethods";
import { contextData } from "../../context/ContextProvider";
import { decryptToken } from "../Encryption/EncryptDecrypt";
import { useNavigate } from "react-router-dom";

// =============to generate pdf====================
export const GeneratePDF = (meetingId, momVersionD) => {
    const token1 = sessionStorage.getItem("TOKEN")
    if (!momVersionD) {
        console.log("currentMomV is null or undefined");
        return;
    }
    try {
        fetch(Url.downloadMOM.replace('{meetingId}', `${meetingId}`)
            .replace('{version}', `${momVersionD}`).replace("{isAttendeeRequired}", "Y"),
            {
                headers: {
                    'Authorization': `Bearer ${token1}`,
                },
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to retrieve PDF. Status code: ${response.status}`);
                }
                return response.blob();
            })
            .then(blob => {
                // Create a Blob URL for the PDF
                const blobUrl = URL.createObjectURL(blob);

                // Create a link element
                const link = document.createElement('a');

                // Set the link's href attribute to the Blob URL
                link.href = blobUrl;

                // Set the download attribute to specify the filename
                const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace('T', '_').replace(/\..+/, '');
                link.download = `MOM_${timestamp}.pdf`;

                // Append the link to the document body
                document.body.appendChild(link);

                // Trigger a click on the link to initiate the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            })
            .catch(error => {
                console.log(error.message);
            });
    } catch (error) {
        console.log('Error generating PDF:', error);
    }
}

// ================================================common react Select dropDown style =============================================

export const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "white" : "black",
        backgroundColor: state.isSelected ? "#00ADEE" : "white",
        padding: 10,
        zIndex: 9999,
        height: 20,
        display: "flex",
        alignItems: "center",
        fontSize: 13,
        borderBottom: "2px solid white",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#00ADEE",
            color: "white"
        },
    }),
    menu: (provided, state) => ({
        ...provided,
        width: "100%",
        innerHeight: "22px",
        padding: 0,
        position: "absolute",
        zIndex: 9999,
        display: "block",
        top: 22,
        backgroundColor: "white",
        cursor: "pointer",
    }),
    control: (provided, state) => ({
        border: "1px solid gray",
        borderRadius: 5,
        height: 28,
        width: 125,
        fontSize: 13,
        display: "flex",
        cursor: "pointer",
        "&:focus": {
            outline: "none",
            boxShadow: "none",
        },
    }),
    indicatorSeparator: () => ({
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        transform: 'scale(0.8)',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        textAlign: 'center'
    }),
};



//table header styles
export const tableHeaderStyle = {
    backgroundColor: "#E2F7FF",
    color: "#00ADEE",
    fontWeight: "bold",
    height: 20,
};


export const color = "#00ADEE";

// Tables Icons Object 

export const createTableIcons = (color = "#00ADEE") => ({
    Add: () => (
        <span >
            <FaPlusSquare size={'20px'} fill={color} />
        </span>
    ),
    Check: () => (
        <span >
            <FaCheck size={'20px'} fill={color} />
        </span>
    ),
    Clear: () => (
        <span >
            <FaTimes size={'20px'} fill={color} />
        </span>
    ),
    Delete: () => (
        <span >
            <FaTrash size={'20px'} fill={color} />
        </span>
    ),
    DetailPanel: () => (
        <span >
            <FaChevronRight size={'20px'} fill={color} />
        </span>
    ),
    Edit: () => (
        <span >
            <FaEdit size={'20px'} fill={color} />
        </span>
    ),
    Export: () => (
        <span >
            <FaSave size={'20px'} fill={color} />
        </span>
    ),
    Filter: () => (
        <span >
            <FaFilter size={'20px'} fill={color} />
        </span>
    ),
    FirstPage: () => (
        <span >
            <FaAngleDoubleLeft size={'20px'} fill={color} />
        </span>
    ),
    LastPage: () => (
        <span >
            <FaAngleDoubleRight size={'20px'} fill={color} />
        </span>
    ),
    NextPage: () => (
        <span >
            <FaChevronRight size={'20px'} fill={color} />
        </span>
    ),
    PreviousPage: () => (
        <span >
            <FaChevronLeft size={'20px'} fill={color} />
        </span>
    ),
    ResetSearch: () => (
        <span >
            <FaTimes size={'20px'} fill={color} />
        </span>
    ),
    Search: () => (
        <span >
            <FaSearch size={'20px'} fill={color} />
        </span>
    ),
    ThirdStateCheck: () => (
        <span >
            <FaMinus size={'20px'} fill={color} />
        </span>
    ),
    ViewColumn: () => (
        <span >
            <FaThList size={'20px'} fill={color} />
        </span>
    ),
});





export const getEmailClassification = (emailDetailss) => {
    if (!emailDetailss || !Array.isArray(emailDetailss)) {
       
        return { to: [], from: [], optional: [] };
    }
    let to = [];
    let from = [];
    let optional = [];

    emailDetailss.forEach((detail) => {
        const emailType = detail.emailTypeMaster?.emailType;
        switch (detail.emailTypeMaster?.emailTypeId) {
            case 1:
                from.push(detail);
                break;
            case 2:
                to.push(detail);
                break;
            case 3:
                optional.push(detail);
                break;
            default:
                break;
        }
    });

    return { to, from, optional };
};

export const getAllToFromOptionalEmailArr = (participantsList) => {
    let allFullNamesArr = [];
    let allEmailIdArr = [];

    participantsList?.forEach((i) => {
        allEmailIdArr.push(i?.emailId);
        allFullNamesArr?.push(i?.fullName);

    });

    return { allFullNamesArr, allEmailIdArr };
};




//function to remove first line 
export const firstLineTextFromHtml = (html) => {
    html = html.trim();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const textContent = doc.body.textContent || "";
    const firstLine = textContent.trim().split('\n')[0].trim();

    return firstLine;
}

export const sanitizeHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.innerHTML;
}

export const stripHtmlTags = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}


//common modal style 
export const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};


//auditee dropDown style 

export const customStylesAuditee = {
    ...customStyles,
    menu: (provided, state) => ({
        ...provided,
        width: "100%",
        innerHeight: "22px",
        padding: 0,
        position: "absolute",
        zIndex: 9999,
        display: "block",
        top: "100%",
        left: 0,
        backgroundColor: "white",
        cursor: "pointer",
        maxHeight: "110px", 
        overflowY: 'auto', 
    }),
    control: (provided, state) => ({
        ...provided,
        border: "1px solid gray",
        borderRadius: 5,
        minHeight: 32,
        maxHeight: "auto",
        width: "100%",
        fontSize: 13,
        display: "flex",
        cursor: "pointer",
        "&:focus": {
            outline: "none",
            boxShadow: "none",
        },
    }),
};


// common table syntax
const theme = createTheme();
const tableIconsTB = createTableIcons();
export const TaskboardTable = ({ data, columns }) => (

    <div className="taskboard-table-container tsb-table" data-testid="taskboard-table">
        <ThemeProvider theme={theme}>
            <MaterialTable
                data={data}
                columns={columns}
                localization={{ body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> } }}
                icons={tableIconsTB}
                options={{
                    toolbar: false,
                    draggable: false,
                    search: false,
                    pageSizeOptions: [5, 10, 15, 20],
                    pageSize: 10,
                    headerStyle: {
                        position: 'sticky',
                        top: -1,
                        ...tableHeaderStyle
                    },
                    maxBodyHeight: '64vh',
                    minBodyHeight: '64vh',
                    backgroundColor: 'white',
                }}
            />
        </ThemeProvider>
    </div>
);


//task board cards common component 
export const TaskCard = ({ task, onClick, Status }) => {

    return (
        <div className='improgress-child-div' onClick={onClick}>
            <div className='tb-card-info-cont'>
                <div style={{ width: Status == "No" && "19rem" }} className='tb-card-task-name'>
                    <span style={{ width: "100px" }}>
                        {task?.taskName.substring(0, 1).toUpperCase() + task?.taskName.substring(1, task?.taskName.length)}
                    </span>
                </div>
                <div className='tb-card-dates-cont'>
                    <div className='tb-card-text' style={{ color: '#999999', fontSize: "14px" }}>Assigned date&nbsp;</div>
                    <div className='colonDiv'>:</div>
                    <div className='tb-card-text'>&nbsp;&nbsp;&nbsp;{task?.parsedAssignedDate}</div>

                    <div className='tb-card-text' style={{ color: '#999999' }}>ETA&nbsp;</div>
                    <div className='colonDiv'>:</div>
                    <div className='tb-card-text'>&nbsp;&nbsp;&nbsp;{task?.parsedEtaDate}</div>

                    <div className='tb-card-text' style={{ fontSize: "14px" }}>Assigned by&nbsp;</div>
                    <div className='colonDiv'>:</div>
                    <div className='assiged-by-cont' style={{ fontSize: "14px" }}>&nbsp;&nbsp;&nbsp;{task?.assignedBy?.fullName}</div>
                </div>
            </div>

            {Status !== "No" && <div className='tb-card-icon-cont'>
                <svg id="Group_28942" data-name="Group 28942" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28.148 28.15">
                    <path id="Path_152736" data-name="Path 152736" d="M11.981,26.179a.592.592,0,0,1-.415-.171.586.586,0,0,1-.161-.529l.829-4.146a.575.575,0,0,1,.161-.3l9.123-9.123a1.763,1.763,0,0,1,2.488,0l1.658,1.658a1.761,1.761,0,0,1,0,2.488l-9.123,9.123a.583.583,0,0,1-.3.161l-4.146.829A.622.622,0,0,1,11.981,26.179Zm1.37-4.444-.622,3.109,3.109-.622,9-9a.587.587,0,0,0,0-.829l-1.658-1.658a.587.587,0,0,0-.829,0Zm2.776,3.028h.012Z" transform="translate(1.97 1.97)" fill="#00adee" />
                    <path id="Path_152737" data-name="Path 152737" d="M11.143,24.112H2.932A2.935,2.935,0,0,1,0,21.18V5.932A2.935,2.935,0,0,1,2.932,3H5.278a.586.586,0,1,1,0,1.173H2.932A1.762,1.762,0,0,0,1.173,5.932V21.18a1.762,1.762,0,0,0,1.759,1.759h8.21a.586.586,0,1,1,0,1.173Z" transform="translate(0 0.519)" fill="#00adee" />
                    <path id="Path_152738" data-name="Path 152738" d="M17.278,13.556a.587.587,0,0,1-.586-.586V5.932a1.762,1.762,0,0,0-1.759-1.759H12.586a.586.586,0,0,1,0-1.173h2.346a2.935,2.935,0,0,1,2.932,2.932V12.97A.587.587,0,0,1,17.278,13.556Z" transform="translate(2.075 0.519)" fill="#00adee" />
                    <path id="Path_152739" data-name="Path 152739" d="M12.8,7.037H5.759A1.762,1.762,0,0,1,4,5.278V2.932a.587.587,0,0,1,.586-.586H6.4a2.933,2.933,0,0,1,5.747,0H13.97a.587.587,0,0,1,.586.586V5.278A1.762,1.762,0,0,1,12.8,7.037ZM5.173,3.519V5.278a.588.588,0,0,0,.586.586H12.8a.588.588,0,0,0,.586-.586V3.519H11.624a.587.587,0,0,1-.586-.586,1.759,1.759,0,0,0-3.519,0,.587.587,0,0,1-.586.586Z" transform="translate(0.692)" fill="#00adee" />
                    <path id="Path_152740" data-name="Path 152740" d="M15.316,9.173H3.586A.586.586,0,1,1,3.586,8H15.316a.586.586,0,0,1,0,1.173Z" transform="translate(0.519 1.383)" fill="#00adee" />
                    <path id="Path_152741" data-name="Path 152741" d="M15.316,12.173H3.586a.586.586,0,1,1,0-1.173H15.316a.586.586,0,0,1,0,1.173Z" transform="translate(0.519 1.902)" fill="#00adee" />
                    <path id="Path_152742" data-name="Path 152742" d="M15.316,15.173H3.586a.586.586,0,0,1,0-1.173H15.316a.586.586,0,0,1,0,1.173Z" transform="translate(0.519 2.421)" fill="#00adee" />
                </svg>
            </div>
            }
        </div>
    );
};


//custom datepicker of taskboard 


export const CustomDatePicker = ({ selectedDate, onDateChange, isDisabled, customStyles }) => (
    <div className='task-modal-datepicker'>
        <span style={{ marginRight: "15px", display: "flex" }}>
            <svg
                id="calendar-line-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="19.119px"
                height="24.122px"
                viewBox="0 0 27.119 27.122"
            >
                <path
                    id="Path_15922"
                    data-name="Path 15922"
                    d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                    fill="black"
                />
            </svg>
        </span>
        <DatePicker
            disabled={isDisabled}
            selected={selectedDate}
            dateFormat="dd/MM/yyyy"
            style={customStyles}
            onChange={onDateChange}
        />
    </div>
);



export const FacilityTableRow = ({ rowData, colorr }) => {
    const renderMomStatusIcon = () => {
        switch (rowData.momStatus) {
            case "Save":
                return <FaCheckCircle size={12} color={colorr} />;
            case "Send":
                return <IoIosShareAlt size={18} color={colorr} />;
            default:
                return "NA";
        }
    };

    const renderMomStatusText = () => {
        switch (rowData.momStatus) {
            case "Save":
                return "Saved";
            case "Send":
                return "Shared";
            default:
                return "NA";
        }
    };

    return (
        <div className='facillity-table-row-data momStatus-row-data'>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", paddingRight: '10px' }}>
                {renderMomStatusIcon()}
            </span>
            {rowData.meetingSubject &&
                <div className='momStatus-tool-tip'>
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", paddingRight: '10px' }}>
                        {renderMomStatusText()}
                    </span>
                </div>
            }
        </div>
    );
};

// utils/columns.js
export const getColumns = (headStyle, titleStyle, dataStyle, usermail2, rbac, setViewPastMeeting, handleEditAccess, Hr_backgroundColor, DeptType, navigate) => {
   
    return [
    {
        title: <p style={headStyle}>SR NO.</p>,
        field: "",
        sorting: false,
        render: (rowData) => (
            <div style={titleStyle} className={DeptType == "Hr" ? "hr-table-row-data" : DeptType == "It" ? "IT-table-row-data" : DeptType == "Fa" ? "facillity-table-row-data" : "governance-table-row-data"}>
                <span style={{ width: '50px', textAlign: 'right', paddingRight: '8px' }}>{rowData.index}</span>
            </div>
        ),
    },
    {
        title: <p style={headStyle}>TITLE</p>,
        field: "meetingSubject",
        sorting: false,
        render: (rowData) => (
            <div style={{ ...dataStyle, position: "relative" }} className={DeptType == "Hr" ? "hr-table-row-data hr-title-row" : DeptType == "It" ? "IT-table-row-data it-title-row" : DeptType == "Fa" ? "facillity-table-row-data fa-title-row" : "governance-table-row-data fa-title-row"}>
                <span className="elipsisData" style={{ width: "254px" }}>{rowData.meetingSubject}</span>
                {rowData.meetingSubject && <div className='meetingSubject-tool-tip'>{rowData.meetingSubject}</div>}
            </div>
        ),
    },
    {
        title: <p style={headStyle}>DATE & TIME</p>,
        field: "startDate",
        sorting: false,
        render: (rowData) => (
            <div style={titleStyle} className={DeptType == "Hr" ? "hr-table-row-data" : DeptType == "It" ? "IT-table-row-data" : DeptType == "Fa" ? "facillity-table-row-data" : "governance-table-row-data"}>
                <span style={{ width: "200px" }}>{rowData.parseStartDate},{rowData.startTime}-{rowData.endTime === "11:59 PM" ? "12:00 AM" : rowData.endTime}</span>
            </div>
        ),
    },
    {
        title: <p style={headStyle}>DURATION</p>,
        field: "duration",
        sorting: false,
        render: (rowData) => (
            <div style={{ ...titleStyle }} className={DeptType == "Hr" ? "hr-table-row-data" : DeptType == "It" ? "IT-table-row-data" : DeptType == "Fa" ? "facillity-table-row-data" : "governance-table-row-data"}>
                <span>{rowData?.duration}</span>
            </div>
        ),
    },

    {
        title: <p style={headStyle}>VERSION</p>,
        field: "momVersion",
        sorting: false,
        render: (rowData) => (
            <div style={{ ...titleStyle, width: "70px" }} className={DeptType == "Hr" ? "hr-table-row-data" : DeptType == "It" ? "IT-table-row-data" : DeptType == "Fa" ? "facillity-table-row-data" : "governance-table-row-data"}>
                <span>{!rowData?.momVersion ? "NA" : rowData?.momVersion}</span>
            </div>
        ),
    },
    {
        title: <p style={{ ...headStyle }}>RECORDED BY</p>,
        field: "momRecordedBy",
        sorting: false,
        render: (rowData) => (
            <div style={{ ...titleStyle, width: "120px", position: 'relative' }} className={DeptType == "Hr" ? "hr-table-row-data recorded-by-row" : DeptType == "It" ? "IT-table-row-data recorded-by-row" : DeptType == "Fa" ? "facillity-table-row-data recorded-by-row" : "governance-table-row-data recorded-by-row"}  >
                <span className="elipsisData">{!rowData?.momRecordedBy?.fullName ? "NA" : rowData?.momRecordedBy?.fullName}</span>
                {rowData?.momRecordedBy?.fullName && <div className='recorded-by-tool-tip1'>{rowData?.momRecordedBy?.fullName}</div>}
            </div>
        ),
    },
    {
        title: <p style={{ ...headStyle, paddingRight: "5px" }}>STATUS</p>,
        field: "momStatus",
        sorting: false,
        render: (rowData) => (
            <div style={{ ...titleStyle, position: 'relative' }} className={DeptType == "Hr" ? "hr-table-row-data momStatus-row-data" : DeptType == "It" ? "IT-table-row-data momStatus-row-data" : DeptType == "Fa" ? "facillity-table-row-data momStatus-row-data" : "governance-table-row-data momStatus-row-data"} key={rowData.id}>
                <FacilityTableRow rowData={rowData} colorr={Hr_backgroundColor} />
            </div>
        ),
    },
    {
        title: <p style={{ padding: '0px 6px' }}>ACTION</p>,
        field: "",
        sorting: false,
        render: (props) => (
            <div className="action-btns" style={{ display: "flex", gap: "3px" }}>
                <span className="hr-dot" style={{ backgroundColor: Hr_backgroundColor }}></span>
                <span className="hr-dot" style={{ backgroundColor: Hr_backgroundColor }}></span>
                <span className="hr-dot" style={{ backgroundColor: Hr_backgroundColor }}></span>



                <TooltipBox
                    meetingSummary={props?.meetingSummary}
                    emailDetails={props?.emailDetail}
                    usermail={usermail2}
                    mid={props?.mid}
                    momVersion={props?.momVersion}
                    setViewPastMeeting={setViewPastMeeting}
                    handleEditAccess={()=>handleEditAccess(props, navigate)}
                    GeneratePDF={GeneratePDF}
                    props={props}
                />
            </div>
        ),
    },
    ];
};



//status selector common for taskboard

export const StatusSelector = ({ isView, options, customStyles, dataToEdit, handleStatusChange }) => {
    return (
        <div className={isView ? 'task-modal-status-selector2' : 'task-modal-status-selector'}>
            <Select
                isSearchable={false}
                options={options}
                isDisabled={isView}
                styles={{
                    ...customStyles,
                    control: (provided, state) => ({
                        ...provided,
                        borderRadius: 5,
                        height: "100%",
                        width: "100%",
                        fontSize: 14,
                    }),
                }}
                value={{
                    value: dataToEdit?.taskStatus,
                    label: dataToEdit?.taskStatus
                }}
                onChange={(e) => handleStatusChange(e)}
            />
        </div>
    );
};




export const useRBAC = (useCase) => {
    let rrbac = Cuurent_RBAC_roles();


    const storedRbacRoles = JSON.parse(rrbac);
    const userRole = sessionStorage.getItem("USER");
    const [rbac, setRbac] = useState({});

    useEffect(() => {
        if (userRole !== "USER") {
            const roleWithUseCase = storedRbacRoles?.find(role => role.useCase === useCase);
            if (roleWithUseCase) {
                setRbac(roleWithUseCase);
            }
        }
    }, [useCase]);

    return rbac;
};


// =================================cancelled by div======================

export const CanceledBy = ({ agendaDivHeight, fullView, setFullView }) => {
    return (
        <div>
            <div className="UPM-view-modal-row2">
                <div className="label-title">
                    <p>Cancelled By</p>
                    <span className="cancelledBySpanColon">:</span>
                </div>
                <div style={{ fontSize: '13px', paddingLeft: '5%' }}>{fullView?.data?.cancelledByName}</div>
            </div>
            <div className="UPM-view-modal-row2">
                <div className="label-title">
                    <p>Cancellation Reason</p>
                    <span>:</span>
                </div>
                <div style={{ fontSize: '13px', paddingLeft: '5%' }}>{fullView?.data?.cancelReason}</div>
            </div>
        </div>
    );
};


// ========================================icons div common===========================================
export const TooltipBox = ({ meetingSummary, emailDetails, usermail, mid, momVersion, setViewPastMeeting, handleEditAccess, GeneratePDF, props }) => {


    const getEmailClassification = (emailDetailss) => {
        let to = [];
        let from = [];
        let optional = [];

        if (emailDetailss && Array.isArray(emailDetailss)) {
            emailDetailss.forEach((detail) => {
                const emailTypeId = detail.emailTypeMaster?.emailTypeId;

                if (emailTypeId !== undefined) {
                    switch (emailTypeId) {
                        case 1:
                            from.push(detail);
                            break;
                        case 2:
                            to.push(detail);
                            break;
                        case 3:
                            optional.push(detail);
                            break;
                        default:
                            break;
                    }
                }
            });
        }

        return { to, from, optional };
    };

    const { to, from, optional } = getEmailClassification(emailDetails);



    const canEdit = (
        (to && to.some(item => item.participantEmail?.includes(usermail))) ||
        (from && from.some(item => item.participantEmail?.includes(usermail))) ||
        (optional && optional.some(item => item.participantEmail?.includes(usermail)))
    );



    return (
        <div className="tooltip-box">
            <div className="tooltip-item" id={meetingSummary ? 'normal' : "disabled"} onClick={() => {
                meetingSummary && setViewPastMeeting({
                    isView: true,
                    meetingId: mid
                });
            }}>
                <BsEye fill='#00ADEE' size={12} /> <p style={{ fontSize: '13px' }}>View</p>
            </div>
            <div className="tooltip-item" id={canEdit ? "normal" : "disabled"} onClick={() => {
                handleEditAccess(props, to, from, optional);
            }}>
                <SlPencil fill='#00ADEE' size={12} /> <p style={{ fontSize: '13px' }}>Edit</p>
            </div>
            <div className="tooltip-item" id={meetingSummary ? "normal" : "disabled"} onClick={() => {
                meetingSummary && GeneratePDF(mid, momVersion);
            }}>
                <BsDownload fill='#00ADEE' size={12} /><p style={{ fontSize: '13px' }}>Download</p>
            </div>
        </div>
    );
};

// ===================================common useEffect in upcoming and all meeting=============================================
export function handleOverflowCheck(setAttendeesDivHeight, setAgendaDivHeight, setMsgDivHeight, isOverflowing) {
    setTimeout(() => {
        const div = document.getElementById("agenda_div");
        let res = isOverflowing(div);

        const div2 = document.getElementById("message_div");
        let res2 = isOverflowing(div2);

        const div3 = document.getElementById("attendees_div");
        let res3 = isOverflowing(div3);

        if (res3) {
            setAttendeesDivHeight(res3);
        }

        if (res) {
            setAgendaDivHeight(res);
        }

        if (res2) {
            setMsgDivHeight(res2);
        }



    }, 1000);
}
export const nearestTime = () => {

    let now = new Date();
    let minutes = now.getMinutes();

    // If minutes are greater than or equal to 30, add 30 minutes
    if (minutes >= 30) {
        now.setMinutes(0); // Reset minutes to 0
        now.setHours(now.getHours() + 1); // Add 1 hour
    } else {
        now.setMinutes(30); // Set minutes to 30
    }

    // If the current time is 12:30 AM, adjust the hours to 12:00 AM
    if (now.getHours() === 0 && now.getMinutes() === 0) {
        now.setHours(24); // Set to 24 (midnight)
    }

    // Format the time
    let formattedTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    return formattedTime;
}


// ==============================setupmeeting  body repeat===================







export const extractMeetingData = (meetingData) => {
    const {
        meetingSubject,
        startDate,
        endDate,
        startTime,
        endTime,
        emailDetails,
        meetingAgenda,
        meetingLocation,
        message,
        participantsList,
        emailDetail,
        cancelReason,
        cancelledByName
    } = meetingData;

    const { to, from, optional } = getEmailClassification(emailDetail);



    const attendees = [];
    const attendeesArr = participantsList;

    if (attendeesArr) {
        attendeesArr?.forEach(item => {
            attendees.push(" " + item?.fullName);
        });
    }

    const agenda = meetingAgenda
        ? meetingAgenda.split("\n")
        : [];

    return {
        participantsList,
        emailDetail,
        attendees,
        agenda,
        title: meetingSubject || "",
        date: meetingData?.parseStartDate || "",
        startDate: meetingData.parseStartDate || "",
        endDate: meetingData.parseEndDate || "",
        startTime: startTime || "",
        endTime: endTime || "",
        Location: meetingLocation?.location || "",
        Msg: message || "",
        Ownername: from[0]?.employeeMaster?.fullName || "NA",
        cancelledByName: cancelledByName || 'NA',
        cancelReason: cancelReason || 'NA'
    };
};


// ==================handle cancel common in upcoming and all meeting======================

export const handleCancel = async ({
    idToCancelMeeting,
    reason,
    setLoading,
    setOpenCancelModal,
    setSuccessMessage,
    setOpenSuccessModal,
    setToggleForCount,
    setFailMessage,
    setOpenFailModal,
    setSessionExpiredModal,
    token = sessionStorage.getItem('TOKEN'),
}) => {
    setLoading(true);
    setOpenCancelModal(false);

    let body = {
        cancelReason: reason
    };

    try {
        const cancelMeetingResp = await PUT(Url.cancelUpcomingMeeting.replace("{mid}", `${idToCancelMeeting}`), token, body);

        if (cancelMeetingResp.SUCCESS) {
            setLoading(false);
            setSuccessMessage('Meeting cancelled successfully.');
            setOpenSuccessModal(true);
            setToggleForCount((prevState) => !prevState);
        } else if (cancelMeetingResp.STATUS === 401) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        }else if (cancelMeetingResp.STATUS === 400) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        }else if (cancelMeetingResp.STATUS === 403) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        }else if (cancelMeetingResp.STATUS === 404) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        }else if (cancelMeetingResp.STATUS === 500) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else {
            setLoading(false);
            setFailMessage("Failed to cancel meeting.");
            setOpenFailModal(true);
        }
    } catch (error) {
        setLoading(false);
        setOpenCancelModal(false);
        setOpenFailModal(true);
        setFailMessage("Failed to cancel meeting.");
    }
};

// Checklist and Observations

// utils.js
export function getDepartmentLabel(latestDepartTag) {
    switch (latestDepartTag) {
        case 1:
            return "HR";
        case 2:
            return "Governance";
        case 3:
            return "IT";
        case 4:
            return "Facility";
        default:
            return "";
    }
}

export function getPeriodLabels(latestQuarter) {
    switch (latestQuarter) {
        case "Quarter 1":
            return "Q1 (April - June)";
        case "Quarter 2":
            return "Q2 (July - September)";
        case "Quarter 3":
            return "Q3 (October - December)";
        case "Quarter 4":
            return "Q4 (January - March)";
        default:
            return "";
    }
}


export const CustomYearPicker = ({
    selectedDate,
    onDateChange,
    isDisabled = false,    // Add isDisabled prop
    customStyles = {},     // Add customStyles prop
}) => {

    return (
        <div className="AuditCal-customdatePicker">
            <DatePicker
                selected={selectedDate}
                onChange={onDateChange}
                showYearPicker
                yearDropdownItemNumber={6}
                dateFormat="yyyy"
                disabled={isDisabled}   // Use isDisabled prop
            />
        </div>
    );
};






export const Cuurent_UserIdProxy = () => {
    let res = decryptToken(sessionStorage.getItem("UserIdProxy1"));

    return res;
};

export const Cuurent_EMAIL = () => {
    let res = decryptToken(sessionStorage.getItem("EMAIL1"));

    return res;
};

export const Cuurent_USERNAME = () => {
    let res = decryptToken(sessionStorage.getItem("USERNAME1"));

    return res;
};

export const Cuurent_StaffId = () => {
    let res = decryptToken(sessionStorage.getItem("StaffId1"));

    return res;
};

export const Cuurent_RBAC_roles = () => {

    let res = decryptToken(sessionStorage.getItem("RBAC_roles1"));

    return res;
};

export const Cuurent_USER_ROLES = () => {
    let rolesStr = sessionStorage.getItem("USER_ROLES1")?.split(",");
    let res = decryptToken(rolesStr);


    return res;
};

export const Cuurent_gender = () => {
    let res = decryptToken(sessionStorage.getItem("gender1"));

    return res;
};

export const Cuurent_USER = () => {
    let res = decryptToken(sessionStorage.getItem("ROLE1"));

    return res;
};


export const customStylesMulti = {
    control: (provided) => ({
        ...provided,
        border: '1px solid #B8B8B8',
        borderRadius: '5px',
        boxShadow: 'none',
        minHeight: '34px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
        color: state.isSelected ? 'white' : state.isFocused ? '#007bff' : 'black',
        fontSize: "14px",
        margin: "0px",
        borderBottom: "1px solid #ccc",
        height: "30px",
        cursor: 'pointer',
        transition: 'background-color 0.2s, color 0.2s',
        '&:hover': {
            backgroundColor: state.isSelected ? '#0056b3' : '#f8f9fa',
            color: state.isSelected ? 'white' : '#007bff',
        },
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: '122px',
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: '120px',
        overflowY: 'auto',
    }),
    dropdownIndicator: () => ({
        display: 'none' // Hide the dropdown arrow
    }),
    indicatorSeparator: () => ({
        display: 'none' // Hide the indicator separator
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: '6px', // Adjust padding to reduce the size of the clear indicator
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '30px'
    }),
    input: (provided, state) => ({
        ...provided,
        minHeight: '20px', // Adjust the input height as needed
    }),
    placeholder: (provided, state) => ({
        ...provided,
        marginTop: '4px',
        fontSize: '13px'
    }),
};
